module.exports = __webpack_public_path__ + "static/media/superds2.5ba7dbfd.jpeg";